export default "__VITE_ASSET__Bbn$uWyA__"